export default __webpack_public_path__ + "static/assets/f84012e6294562eb0a9914b7762001a2.png";